import getIssueByIdWebsite from "./getIssueByIdWebsite";

const issueWebsiteServices = {
  getIssueByIdWebsite,
};

export default issueWebsiteServices;
